export default __webpack_public_path__ + "static/media/odor.fe20a47f.jpg";